export const ACTIONS_WB_ORDERS = {
  ADD_MAP: 'ADD_WB_OZON',
  CHANGE_ORDER_MAP: 'CHANGE_WB_ORDER_MAP',
  ADD_MAP_PART: 'ADD_MAP_PART',
};

export const addWbOrdersMap = (map) => ({
  type: ACTIONS_WB_ORDERS.ADD_MAP,
  map,
});

export const addWbOrdersPartMap = (map) => ({
  type: ACTIONS_WB_ORDERS.ADD_MAP_PART,
  map,
});

export const changeWbOrdersMap = (item) => ({
  type: ACTIONS_WB_ORDERS.CHANGE_ORDER_MAP,
  item,
});
